import { createContext, useContext } from "react";

export const initGameSettingsState = {

    "audio_volume": 50,
    "music_volume": 50,
    "avatar": ""
};

export const GameSettings = createContext({
    gameState: initGameSettingsState
});

export function useGameSettings() {
    return useContext(GameSettings);
};